import {FindMessageEntry} from "../ai-events/model/find-message.entry";

export class ChatVehicleListEntry {

  constructor(public id: number,
              public plateNumber: string,
              public driverName: string,
              public tabOnline: boolean,
              public findMessageEntry: FindMessageEntry,
              public driverLanguage: string) {
  }
}

export interface ChatState {
  state: 'all' | 'vehicle';
  vehicleChat: ChatVehicleListEntry;
}
